"use client"

import { createContext, useContext, useRef } from "react"

const AudioRefContext = createContext<React.MutableRefObject<HTMLAudioElement | null> | undefined>(void 0)

export function AudioRefProvider({ children}: { children: React.ReactNode}) {
  const sharedRef = useRef<HTMLAudioElement>(null)
  return (
    <AudioRefContext.Provider value={sharedRef}>
      {children}
    </AudioRefContext.Provider>
  )
}

export function useAudioRef() {
  const ctx = useContext(AudioRefContext)
  return ctx
}